import { convertNumberDE } from '../util.js';

// Schwellen der Statuszelle (reference/statuszelle_v2/STATUSZELLE.md §3), auch im Mitarbeiter-Status-Dialog.
const STATUS_UNTERPLAN_ANTEIL = 0.8; // unter 80 % des Monatssolls → Balken amber
const STATUS_RESTURLAUB_KNAPP_TAGE = 5; // Resturlaub ≤ 5 Tage → Wert amber
const STATUS_ABWEICHUNG_TOLERANZ_H = 1; // |Ist − Plan bis heute| < 1 h gilt als "wie geplant"

/** Stunden de-DE, Nachkommastelle nur wenn nötig (47 / 47,5). */
function formatStunden(wert) {
	return convertNumberDE(wert, Number.isInteger(wert) ? 0 : 1);
}

/**
 * Kennzahlen einer Person für die Statuszelle und den Mitarbeiter-Status-Dialog — eine Quelle, damit beide
 * immer dasselbe zeigen. Plan/Ist beziehen sich auf den Abrechnungsmonat (ladeStundenMonat), Resturlaub und
 * Gutzeit-Saldo sind Stände von heute (m.Uebersicht).
 * @param {object} m Mitarbeiter
 * @param {object} [stunden] { StundenGeplant, StundenGeplantBisHeute, StundenErfasst } aus stundenMonat.Mitarbeiter
 * @returns {object}
 */
function berechneStatusWerte(m, stunden = {}) {
	const plan = stunden.StundenGeplant || 0;
	const planBisHeute = stunden.StundenGeplantBisHeute || 0;
	const ist = stunden.StundenErfasst || 0;
	const soll = m.Beschaeftigung[0].SollstundenMonat || 0;
	const over = soll > 0 ? Math.max(0, plan - soll) : 0;
	// Abweichung Ist − Plan bis heute (Minus als echtes U+2212)
	const abweichung = ist - planBisHeute;
	const abwKlasse = Math.abs(abweichung) < STATUS_ABWEICHUNG_TOLERANZ_H ? 'ok' : abweichung < 0 ? 'lo' : 'hi';
	return {
		plan,
		planBisHeute,
		ist,
		soll,
		over,
		skala: Math.max(plan, soll, ist) || 1,
		unterplant: soll > 0 && !over && plan / soll < STATUS_UNTERPLAN_ANTEIL,
		abweichung,
		abwKlasse,
		// Immer der genaue Wert, auch innerhalb der Toleranz (die bestimmt nur die Farbe, siehe abwKlasse).
		// Unter 0,05 h gilt als 0 (sonst bliebe ein Gleitkomma-Rest wie 0,0000001 als "+0 h" stehen).
		abwText: Math.abs(abweichung) < 0.05 ? '±0 h' : `${abweichung > 0 ? '+' : '−'}${formatStunden(Math.abs(abweichung))} h`,
		rest: m.Uebersicht.Resturlaub ?? 0,
		anspruch: m.Beschaeftigung[0].Urlaub?.[0]?.UrlaubsanspruchSumme || 0,
		ueb: m.Uebersicht.Ueberstunden || 0,
		agKosten: m.Uebersicht.AGKostenProStunde || 0,
	};
}

export {
	STATUS_UNTERPLAN_ANTEIL,
	STATUS_RESTURLAUB_KNAPP_TAGE,
	STATUS_ABWEICHUNG_TOLERANZ_H,
	formatStunden,
	berechneStatusWerte,
};
